var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-modal',_vm._g(_vm._b({attrs:{"name":"project-create","title":"Projekt erstellen","width":1200}},'base-modal',_vm.$attrs,false),_vm.$listeners),[_c('project-form',{attrs:{"project":_vm.project,"type":"create"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }